export default "__VITE_ASSET__wrxbFgO0__"